import React, { useRef, useState } from 'react';
import styles from './index.module.less';
import Image from 'next/image';
import classNames from 'classnames';
import Link from 'next/link';
import UploadVideo from '../UploadVideo';
import UploadUsername from '../UploadUsername';
import { useTranslation } from 'next-i18next';
import { EventName } from '@/shared/event-types';
import { ga_logEvent } from '@/shared/ga';
import UploloadFaceNew from '../UploadFaceNew';
import AgreeSearch from '@/components/Content-Monitoring/Cpns/AgreeSearch';
import TermsOfUseModel from '@/components/Content-Monitoring/Cpns/TermsOfUseModel';

const Index: React.FC<any> = ({
  type,
  callBackName,
  Reset,
  content,
  loading,
  setLoading,
  videoDelete,
  setVideoDelete,
  isSearching,
  setIsSearching,
  onSearchClick,
  imageSearchUrl,
  setImageSearchUrl,
  onRegisterRemoveImage,
}) => {
  const { t } = useTranslation('common');
  const reverseSearchHeaderRef = useRef<HTMLDivElement>(null);
  // 是否显示TermsOfUseModel
  const [isShowTermsOfUseModel, setIsShowTermsOfUseModel] = useState(false);
  // 是否勾选隐私协议
  const [isAgreePrivacy, setIsAgreePrivacy] = useState(false);
  // 是否是从搜索按钮触发打开的隐私协议对话框
  const [isFromSearchButton, setIsFromSearchButton] = useState(false);
  // 待搜索的图片 URL（用于从搜索按钮触发隐私协议对话框时保存）
  const [pendingSearchImageUrl, setPendingSearchImageUrl] = useState<string>('');

  const getRouterPath = (type: string) => {
    const routerMap = new Map<string, string>();
    routerMap.set('username', 'reverse-username-search');
    routerMap.set('face', 'reverse-face-search');
    routerMap.set('video', 'reverse-video-search');
    routerMap.set('photo', 'reverse-photo-search');
    return `/content-monitoring/${routerMap.get(type)}`;
  };

  const handleLinkClick = () => {
    Reset();
  };

  const scrollToReverseSearchHeader = () => {
    if (reverseSearchHeaderRef.current) {
      reverseSearchHeaderRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.main}>
          <h1>{content.contentInfo.hero.title}</h1>
          <div>{content.contentInfo.hero.desc}</div>
          <div className={styles.rights}>
            <div>
              <span>✓</span>
              <span>
                <span>{content.contentInfo.hero.tags[0]}</span>
              </span>
            </div>
            <div>
              <span>✓</span>
              <span>
                <span>{content.contentInfo.hero.tags[1]}</span>
              </span>
            </div>
          </div>
          <div className={styles.options} ref={reverseSearchHeaderRef}>
            <ul className={styles.header}>
              <li
                className={classNames({
                  [styles.active]: type === 'username',
                })}
                onClick={() => {
                  ga_logEvent(EventName.switch_reverse_search_tab);
                }}
              >
                <Link href={getRouterPath('username')} onClick={handleLinkClick}>
                  <Image
                    src="/images/Content-Monitoring/1-user.svg"
                    alt="erasa"
                    width={20}
                    height={20}
                    fetchPriority="high"
                    priority
                  ></Image>
                  <span>{t('USERNAME')}</span>
                </Link>
              </li>
              <li
                className={classNames({
                  [styles.active]: type === 'face',
                })}
                onClick={() => {
                  ga_logEvent(EventName.switch_reverse_search_tab);
                }}
              >
                <Link href={getRouterPath('face')} onClick={handleLinkClick}>
                  <Image
                    src="/images/Content-Monitoring/2-camer.svg"
                    alt="erasa"
                    width={20}
                    height={20}
                    fetchPriority="high"
                    priority
                  ></Image>
                  <span>{t('FACE')}</span>
                </Link>
              </li>
              <li
                className={classNames({
                  [styles.active]: type === 'video',
                })}
                onClick={() => {
                  ga_logEvent(EventName.switch_reverse_search_tab);
                }}
              >
                <Link href={getRouterPath('video')} onClick={handleLinkClick}>
                  <Image
                    src="/images/Content-Monitoring/3-video.svg"
                    alt="erasa"
                    width={20}
                    height={20}
                    fetchPriority="high"
                    priority
                  ></Image>
                  <span>{t('VIDEO')}</span>
                </Link>
              </li>
              <li
                className={classNames({
                  [styles.active]: type == 'photo',
                })}
                onClick={() => {
                  ga_logEvent(EventName.switch_reverse_search_tab);
                }}
              >
                <Link href={getRouterPath('photo')} onClick={handleLinkClick}>
                  <Image
                    src="/images/Content-Monitoring/4-photo.svg"
                    alt="erasa"
                    width={20}
                    height={20}
                    fetchPriority="high"
                    priority
                  ></Image>
                  <span>{t('PHOTO')}</span>
                </Link>
              </li>
            </ul>
            {/* Username */}
            {type == 'username' && (
              <UploadUsername
                callBackName={callBackName}
                loading={loading}
                setLoading={setLoading}
                setIsSearching={setIsSearching}
                scrollToReverseSearchHeader={scrollToReverseSearchHeader}
              />
            )}
            {/* face */}
            {type == 'face' && (
              <div>
                <UploloadFaceNew
                  isSearching={isSearching}
                  isAgreePrivacy={isAgreePrivacy}
                  setIsShowTermsOfUseModel={(isShow: boolean, pendingImageUrl?: string) => {
                    setIsShowTermsOfUseModel(isShow);
                    setIsFromSearchButton(isShow);
                    setPendingSearchImageUrl(pendingImageUrl || '');
                  }}
                  onSearchClick={onSearchClick}
                  title={t('Identity & Protect Your Face')}
                  subtitle={t('Identity & Protect Your Face')}
                  imageUrl="https://res-front.pumpsoul.com/prod-erasa/image/content-monitoring/uploadImg3.webp"
                  imageSearchUrl={imageSearchUrl}
                  setImageSearchUrl={setImageSearchUrl}
                  setIsAgreePrivacy={setIsAgreePrivacy}
                  type="face"
                  onRegisterRemoveImage={onRegisterRemoveImage}
                />
                <AgreeSearch
                  isAgreePrivacy={isAgreePrivacy}
                  setIsAgreePrivacy={setIsAgreePrivacy}
                  setIsShowTermsOfUseModel={setIsShowTermsOfUseModel}
                />
              </div>
            )}
            {type == 'photo' && (
              <div>
                <UploloadFaceNew
                  isSearching={isSearching}
                  isAgreePrivacy={isAgreePrivacy}
                  setIsShowTermsOfUseModel={(isShow: boolean, pendingImageUrl?: string) => {
                    setIsShowTermsOfUseModel(isShow);
                    setIsFromSearchButton(isShow);
                    setPendingSearchImageUrl(pendingImageUrl || '');
                  }}
                  onSearchClick={onSearchClick}
                  title={t('Reverse Image Search')}
                  subtitle={t('Find your images online — instantly')}
                  imageUrl="https://res-front.pumpsoul.com/prod-erasa/image/content-monitoring/uploadPhoto.webp"
                  imageSearchUrl={imageSearchUrl}
                  setImageSearchUrl={setImageSearchUrl}
                  setIsAgreePrivacy={setIsAgreePrivacy}
                  type="photo"
                  onRegisterRemoveImage={onRegisterRemoveImage}
                />
                <AgreeSearch
                  isAgreePrivacy={isAgreePrivacy}
                  setIsAgreePrivacy={setIsAgreePrivacy}
                  setIsShowTermsOfUseModel={setIsShowTermsOfUseModel}
                />
              </div>
            )}
            {type == 'video' && (
              <UploadVideo
                callBackName={callBackName}
                loading={loading}
                setLoading={setLoading}
                videoDelete={videoDelete}
                setVideoDelete={setVideoDelete}
                setIsSearching={setIsSearching}
              />
            )}
            {type != 'video' && type != 'face' && type != 'photo' && (
              <div className={styles.bottomIntro}>
                <Image
                  src="/images/common/green-right.svg"
                  alt="erasa"
                  width={15}
                  height={15}
                  fetchPriority="high"
                  priority
                ></Image>
                <span>{t('no signup or credit card needed')}</span>
              </div>
            )}
          </div>
        </div>
      </div>
      {isShowTermsOfUseModel && (
        <TermsOfUseModel
          setIsShowTermsOfUseModel={setIsShowTermsOfUseModel}
          onAgree={() => {
            setIsAgreePrivacy(true);
            setIsShowTermsOfUseModel(false);
            // 只有从搜索按钮触发的隐私协议对话框，同意后才自动执行搜索
            if (isFromSearchButton && pendingSearchImageUrl) {
              setImageSearchUrl(pendingSearchImageUrl);
              onSearchClick?.(pendingSearchImageUrl);
            }
            setIsFromSearchButton(false);
            setPendingSearchImageUrl('');
          }}
        />
      )}
    </div>
  );
};

export default Index;
